<template>
  <div class="w-100">
    <!-- Larger screen than mobile -->
    <div class="d-none d-md-flex">
      <b-table
        class="w-100 border"
        responsive
        striped
        :items="contacts"
        :fields="contactFields"
      >
        <template #cell(published)="contact">
          <b-form-checkbox
            v-model="contact.item.STATE_PUBLISH"
            class="custom-control-danger"
            name="check-button"
            switch
            :unchecked-value="false"
            @change="onPublishChange(contact.item.ID_CONTACT_US, $event)"
          />
        </template>
        <template #cell(login_cs)="contact">
          <b-form-checkbox
            v-model="contact.item.login_cs"
            class="custom-control-danger"
            name="check-button"
            switch
            :unchecked-value="false"
            @change="onLoginCSChange(contact.item.ID_CONTACT_US, $event)"
          />
        </template>
        <template #cell(action)="contact">
          <div class="d-flex justify-content-between">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="btn-icon mr-1"
              @click="
                $router.push({
                  name: 'admin-settings-contacts-edit',
                  params: { contactId: contact.item.ID_CONTACT_US },
                })
              "
            >
              <feather-icon icon="Edit3Icon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="btn-icon mr-1"
              @click="showMsgBoxDelete(contact.item.ID_CONTACT_US)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- Mobile screen -->
    <div class="d-flex d-md-none flex-column">
      <b-row
        v-for="(item, index) in contacts"
        :key="item.ID_CONTACT_US"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">{{ item.NAME_CONTACT_US || '-' }}</strong>
          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="btn-icon mr-1"
              @click="
                $router.push({
                  name: 'admin-settings-contacts-edit',
                  params: { contactId: item.ID_CONTACT_US },
                })
              "
            >
              <feather-icon icon="Edit3Icon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="btn-icon mr-1"
              @click="showMsgBoxDelete(item.ID_CONTACT_US)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </b-col>
        <b-col cols="12" class="d-flex flex-wrap">
          <div style="font-size: 0.75rem;">
            <p><strong>NIK: </strong>{{ item.NIK_CONTACT_US || '-' }}</p>
            <p><strong>PHONE: </strong>{{ item.PHONE_CONTACT_US || '-' }}</p>
            <p><strong>EMAIL: </strong>{{ item.EMAIL_CONTACT_US || '-' }}</p>
            <p>
              <strong>PUBLISHED: </strong>
              <b-form-checkbox
                v-model="item.STATE_PUBLISH"
                class="custom-control-danger"
                name="check-button"
                switch
                :unchecked-value="false"
                @change="onPublishChange(item.ID_CONTACT_US, $event)"
              />
            </p>
            <p>
              <strong>LOGIN CS: </strong>
              <b-form-checkbox
                v-model="item.login_cs"
                class="custom-control-danger"
                name="check-button"
                switch
                :unchecked-value="false"
                @change="onLoginCSChange(item.ID_CONTACT_US, $event)"
              />
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BTable, BFormCheckbox, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BFormCheckbox,
    BButton,
  },

  directives: {
    Ripple,
  },

  data() {
    return {
      contacts: [],
      contactFields: [
        { key: 'NAME_CONTACT_US', label: 'Name', sortable: true },
        { key: 'NIK_CONTACT_US', label: 'NIK', sortable: true },
        { key: 'PHONE_CONTACT_US', label: 'Phone', sortable: true },
        { key: 'EMAIL_CONTACT_US', label: 'Email', sortable: true },
        'published',
        'login_cs',
        'action',
      ],
    }
  },

  mounted() {
    this.fetchContacts()
  },

  methods: {
    fetchContacts() {
      this.$http
        .get('/settings/contact')
        .then(res => {
          this.contacts = res.data.data
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
    },

    onPublishChange(contactId, publish) {
      if (publish) {
        this.$http
          .post(`/settings/contact-publish/${contactId}`)
          .then(() => {
            this.$notif(
              'Success',
              'Contact has been successfully published.',
              'success'
            )
            this.fetchContacts()
          })
          .catch(err => {
            this.$notif('Error', `${err.message}`, 'error')
          })
      } else {
        this.$http
          .post(`/settings/contact-unpublish/${contactId}`)
          .then(() => {
            this.$notif(
              'Success',
              'Contact has been successfully unpublished.',
              'success'
            )
            this.fetchContacts()
          })
          .catch(err => {
            this.$notif('Error', `${err.message}`, 'error')
          })
      }
    },
    async onLoginCSChange(contactId, value) {
      return await this.$http.put('/settings/contact-logincs/' + contactId , {
        login_cs: value = value ? 1 : 0
      })
      .then( res => {
        this.fetchContacts()
        this.$notif(
              'Success',
              'Data has been successfully updated.',
              'success'
            )
      })
      .catch(err => console.error(err))
    },
    deleteContact(contactId) {
      return this.$http.delete(`settings/contact/${contactId}`)
    },

    showMsgBoxDelete(contactId) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.deleteContact(contactId)
              .then(() => {
                this.$notif(
                  'Success',
                  'Contact has been successfully deleted.',
                  'success'
                )
                this.fetchContacts()
              })
              .catch(err => {
                this.$notif('Error', `${err.message}`, 'error')
              })
          }
        })
    },
  },
}
</script>
